export { CommunicationBanner } from './CommunicationBanner';
